import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import styles from '../../../components/PerinHealthModel.module.css';
import { useSelector } from 'react-redux';
import {formatDateWithTime} from '../../../utils/dateUtils';
const AdhocModal = ({ show, onHide, adhocDetails }) => {

    const dateFormat = useSelector((state) => state.userInfo.dateFormat);
    return (
        <Modal style={{fontFamily:"Roboto"}} show={show} onHide={onHide} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title style={{fontSize:"20px"}}>{"Ad-hoc Recording Report"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{display:"flex", flexDirection:"column"}}>
                    <span className="subtitle-2">{"Patient"}</span>
                    <span style={{paddingBottom:"5px"}}>{`${adhocDetails?.patientDetails?.patientFirstName} ${adhocDetails?.patientDetails?.patientLastName}`}</span>
                    <span className="subtitle-2">{"Recording Date"}</span>
                    <span style={{paddingBottom:"5px"}}>{formatDateWithTime(adhocDetails?.adhocDetails?.nonCriticalReportReadingDate, dateFormat)}</span>
                    <span className="subtitle-2">{"Description"}</span>
                    <span style={{paddingBottom:"5px"}}>{adhocDetails?.adhocDetails?.nonCriticalReportDescription}</span>
                    <span className="subtitle-2">{"Symptom"}</span>
                    <span style={{paddingBottom:"5px"}}>{adhocDetails?.adhocDetails?.nonCriticalReportSymptom}</span>
                    <span className="subtitle-2">{"Severity"}</span>
                    <span style={{paddingBottom:"5px"}}>{adhocDetails?.adhocDetails?.nonCriticalReportSeverity}</span>
                </div>
            </Modal.Body>
            <Modal.Footer>
                    <Button 
                        className={styles.ModelButton}
                        onClick={onHide}
                    >
                        {"Close"}
                    </Button>
               
            </Modal.Footer>
        </Modal>
    );
};

export default AdhocModal;
